<template>
  <v-row v-if="singleEmployer" class="add-client-form no-padding">
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-12">
          <h3 class="form-title font">
            {{ singleEmployer.displayName }}
          </h3>
        </div>
      </div>
      <v-form class="row form-row-height" v-model="valid" ref="form">
        <div class="col-md-6">
          <div class="col-md-12 pb-0">
            <label class="font text-gray" for="">Company Legal Name</label>
            <v-text-field
              tabindex="1"
              required
              :rules="requiredRules"
              solo
              v-model.trim="companyName"
              :value="singleEmployer.companyName"
            ></v-text-field>
          </div>
          <div class="col-md-12 pb-0 pt-0">
            <label class="font text-gray" for="">Company Display Name</label>
            <v-text-field
              tabindex="1"
              required
              solo
              :rules="requiredRules"
              v-model.trim="displayName"
              :value="singleEmployer.displayName"
            ></v-text-field>
          </div>

          <div class="col-md-12 pb-0 pt-0">
            <label class="font text-gray" for="">Tax ID </label>
            <v-text-field
              solo
              type="text"
              @keyup="showSlash($event)"
              v-model.trim="taxId"
              required
              placeholder="00-0000000"
              :rules="taxIdRules"
              counter="10"
              maxlength="10"
            ></v-text-field>
          </div>
          <div class="col-md-12 pb-0 pt-0">
            <label class="font text-gray" for=""
              >Approximate Number of Employees</label
            >
            <v-text-field
              tabindex="3"
              required
              v-model.trim="noEmployees"
              :value="singleEmployer.noEmployees"
              solo
            ></v-text-field>
          </div>
          <div class="col-md-12 pb-0 pt-0">
            <label class="font text-gray" for=""
              >Approximate Number of Plan Members</label
            >
            <v-text-field
              tabindex="3"
              v-model.trim="noPlanMembers"
              :value="singleEmployer.noPlanMembers"
              required
              solo
            ></v-text-field>
          </div>
        </div>
        <div class="col-md-6">
          <div class="col-md-12 pb-0">
            <label class="font text-gray" for="">Current Network Vendor</label>
            <v-text-field
              tabindex="10"
              required
              v-model.trim="networkVendor"
              :value="singleEmployer.networkVendor"
              solo
            ></v-text-field>
          </div>
          <div class="col-md-12 pb-0 pt-0">
            <label class="font text-gray" style="font-size: 15px" for=""
              >Current Network Discount Rate (i.e. Precent Discount off Billed
              Charges)
            </label>
            <v-text-field
              class="placeholder-style"
              tabindex="11"
              v-model.trim="networkDiscountRate"
              required
              :value="singleEmployer.networkDiscountRate"
              solo
            ></v-text-field>
          </div>

          <div class="col-md-12 row ma-lg-1 ma-xl-1" >
            <v-btn large class="blue-buttons mt-2 ml-2" @click="accessPortal"
              >Access Employer Portal
            </v-btn>
          </div>
        </div>
      
      </v-form>
        <div class="row justify-end mt-2 mb-2" v-if="$role != 'user'">
          <div>
            <v-btn
              tabindex="16"
              class="blue-buttons mr-6 mb-2"
              @click="$router.push('/employer-advisor/employers')"
            >
              Cancel
            </v-btn>
          </div>
          <div>
            <v-btn
              tabindex="16"
              class="blue-buttons mr-6 mb-2"
              @click="updateEmp()"
            >
              Save & Update
            </v-btn>
          </div>
          <div>
            <v-btn
              tabindex="16"
              class="blue-buttons mr-6 mb-2"
              @click="removeEmployer()"
            >
              Remove Employer
            </v-btn>
          </div>
        </div>
    </div>
    <div class="text-center">
      <v-dialog v-model.trim="dialog" width="800" class="success-modal">
        <v-card>
          <v-card-text class="success-modal">
            <div class="text-center">
              <svg
                width="200"
                height="200"
                viewBox="0 0 200 200"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <rect width="200" height="200" fill="white" />
                <rect width="200" height="200" fill="url(#pattern0)" />
                <defs>
                  <pattern
                    id="pattern0"
                    patternContentUnits="objectBoundingBox"
                    width="1"
                    height="1"
                  >
                    <use
                      xlink:href="#image0_17:586"
                      transform="scale(0.0025)"
                    />
                  </pattern>
                  <image
                    id="image0_17:586"
                    width="400"
                    height="400"
                    xlink:href="data:image/png;base64,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"
                  />
                </defs>
              </svg>
            </div>
            <h2 class="text-center font mt-2">
              Email Successfully send to employer! Please wait for confirmation
            </h2>
            <h2
              class="text-center text-underline blue-light mt-10 pointer"
              @click="done()"
            >
              Done
            </h2>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <removeDialog
      ref="dialog_delete"
      v-on:confirm="confirmRemove"
    ></removeDialog>
    <successModal
      ref="success_modal"
      v-on:confirm="closeSuccessModal"
    ></successModal>
  </v-row>
</template>
<script>
import api from "../../../../services/api";
import RemoveDialog from "../../../TablesTemplate/RemoveDialog.vue";
import successModal from "../../../TablesTemplate/SuccessDialog.vue";

export default {
  components: { RemoveDialog, successModal },
  data() {
    return {
      dialog: false,
      companyName: "",
      displayName: "",
      networkDiscountRate: "",
      networkVendor: "",
      noEmployees: "",
      noPlanMembers: "",
      taxId: "",
    
      valid: false,
      requiredRules: [(v) => !!v || "This field is required"],
      taxIdRules: [
        (v) => !!v || "This field is required",
        (v) =>
          !!/[0-9]{2}\-[0-9]{7}/.test(v) ||
          "Tax ID should contain 9 digits, Please enter your Tax ID in XX-XXXXXXX format",
      ],
    };
  },
  created() {
    this.companyName = this.singleEmployer.companyName;
    this.displayName = this.singleEmployer.displayName;
    this.networkDiscountRate = this.singleEmployer.networkDiscountRate;
    this.networkVendor = this.singleEmployer.networkVendor;
    this.noEmployees = this.singleEmployer.noEmployees;
    this.noPlanMembers = this.singleEmployer.noPlanMembers;
    this.taxId = this.singleEmployer.taxId;
    localStorage.setItem(
      "providerName",
      JSON.stringify(this.singleEmployer.displayName)
    );
  },
  computed: {
    singleEmployer() {
      let emp = "";
      if (localStorage.getItem("employer")) {
        let employer = JSON.parse(localStorage.getItem("employer"));

        emp = employer;
      }

      return emp;
    },
  },
  methods: {
      showSlash(event){
      if (this.taxId.length == 2 && event.keyCode != 8) {
        this.taxId += "-";
      }
      if (this.taxId.length == 10) {
        api()
          .get("auth/isValidTaxId?taxId=" + this.taxId)
          .catch((res) => {
            if (res) {
              this.taxIdRules = [res.response.data.message];
            }
          });
      } else {
        this.taxIdRules = [
          (v) => !!v || "This field is required",
          (v) =>
            !!/[0-9]{2}\-[0-9]{7}/.test(v) ||
            "Tax ID should contain 9 digits, Please enter your Tax ID in XX-XXXXXXX format",
        ];
      }
    },
    closeSuccessModal() {
      this.$router.push("/employer-advisor/employers");
    },
    confirmRemove() {
      let user = JSON.parse(localStorage.getItem("user"));
      let advisorId = user.groupPortal[0].organization.employerAdvisor;
      api()
        .delete(`/advisors/${advisorId}/employers/${this.singleEmployer._id}`)
        .then((res) => {
          if (res) {
            this.$router.push("/employer-advisor/employers");
          }
        });
    },
    removeEmployer() {
      this.$refs.dialog_delete.openPopUp(
        "Are you sure that you want to delete this Employer"
      );
    },
    updateEmp() {
      this.$refs.form.validate();
      if (this.valid) {
        let user = JSON.parse(localStorage.getItem("user"));
        let advisorId = user.groupPortal[0].organization.employerAdvisor;
        let data = {
          companyName: this.companyName,
          displayName: this.displayName,
          taxId: this.taxId,
          noEmployees: this.noEmployees,
          noPlanMembers: this.noPlanMembers,
          networkVendor: this.networkVendor,
          networkDiscountRate: this.networkDiscountRate,
        };
        api()
          .put(
            `/advisors/${advisorId}/employers/${this.singleEmployer._id}`,
            data
          )
          .then((res) => {
            if (res) {
              this.$refs.success_modal.openPopUp(
                "Employer updated successfully"
              );
            }
          });
      }
    },

    accessPortal() {
      let parsed = this.singleEmployer.displayName.split(" ");
      let str = "";
      parsed.forEach((el) => {
        str += el.charAt(0).toUpperCase() + el.slice(1);
      });

      this.$router.push({
        path: "/employer-advisor/employers/" + str,
        params: { name: str },
      });

      // let data = {
      //   'advisorId': advisorId,
      //   'employerId': this.singleEmployer._id
      // }
      // api().post(`/advisors/${advisorId}/employers/${this.singleEmployer._id}/access`, data ).then((res)=>{
      //     if(res.status == 200){
      //        this.dialog = true
      //     }
      // })
    },
    done() {
      this.dialog = false;
      this.$router.push("/employer-advisor/employers");
    },
  },
};
</script>
<style>
.gender-buttons {
  border: 1px solid rgb(197, 185, 185);
  border-radius: 10px;
  cursor: pointer;
}
.placeholder-style
  .v-input__control
  .v-input__slot
  .v-text-field__slot
  input::placeholder {
  color: #1976d2;
  text-decoration: underline;
  font-weight: bold;
  cursor: pointer !important;
}
</style>